<template>
	<div class="shared-user-list-for-roles-and-tags">
		<div class="mt-sm mb-sm">
			<o-toggle
				v-if="setup.self.suiteUserId"
				v-model="setup.showHiddenUser"
				:label="$t('business.userFilter.showHiddenUsers')"
				@input="emits('showHiddenUsers', $event)"/>
		</div>

		<div class="shared-user-list-for-roles-and-tags__header">
			<o-input
				v-model="setup.search"
				suffix-font-icon="icon-interface-search"
				:label="$t('user.rechercherDesUtilisateurs')"/>
			<o-button
				v-if="setup.self.can('UserUpdate')"
				color="info"
				outline
				@click="setup.openUserSelectModalAsync()">
				{{ $t('common.label.addUsers') }}
			</o-button>
		</div>

		<div
			v-if="role || tag"
			class="shared-user-list-for-roles-and-tags__section">
			<o-alert
				v-if="!users.length"
				center
				color="info">
				{{ $t('common.label.noUserAssigned') }} {{ role ? $t('business.roleUserless.role') : $t('business.roleUserless.tag') }}
			</o-alert>

			<o-sticker
				v-for="user in users"
				:key="user.id"
				:muted="!!setup.self.suiteUserId && (!user.hasAccessToArmado || !user.isEnabledForSuite)">
				<div class="shared-user-list-for-roles-and-tags__user">
					<o-avatar
						size="xs"
						:avatar="user.avatarId"
						:name="user.firstName"/>

					<div class="shared-user-list-for-roles-and-tags__user-name">
						<div v-html="`${user.firstName} ${user.lastName}`.mark(setup.search)"/>
						<span class="shared-user-list-for-roles-and-tags__user-mail">{{ user.authLogin }}</span>
						<o-label
							v-if="user.id === setup.self.id"
							size="md"
							color="info">
							{{ $t('common.label.you') }}
						</o-label>
						<o-icon
							v-if="!!setup.self.suiteUserId && (!user.hasAccessToArmado || !user.isEnabledForSuite)"
							v-tooltip="setup.getHiddenUserTooltip(user)"
							font-icon="icon-interface-help-question-circle"/>
					</div>
				</div>

				<template #actions>
					<o-pop-confirm
						v-if="setup.self.can('UserUpdate') && user.id"
						@confirm="setup.removeUserAsync(user.id)">
						<o-icon
							v-tooltip="$t('user.deleteLuserDuTag')"
							font-icon="icon-interface-block"
							ripple="danger"/>
					</o-pop-confirm>
				</template>
			</o-sticker>
		</div>
	</div>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedUserListForRolesAndTagsEmits, SharedUserListForRolesAndTagsProps } from './SharedUserListForRolesAndTagsSetup';
import SharedUserListForRolesAndTagsSetup from './SharedUserListForRolesAndTagsSetup';
const emits = defineEmits<SharedUserListForRolesAndTagsEmits>() as SharedUserListForRolesAndTagsEmits;
const props = withDefaults(defineProps<SharedUserListForRolesAndTagsProps>(), SharedUserListForRolesAndTagsSetup.defaultProps);
const setup = new SharedUserListForRolesAndTagsSetup(props, emits);
// #endregion
</script>

<style scoped lang="less">
.shared-user-list-for-roles-and-tags {
	margin-bottom: var(--space-md);
	border-bottom: 1px solid rgb(var(--rgb-grey-light), 0.6);

	&__header {
		display: flex;
		gap: var(--space-sm);
		align-items: center;
		margin-bottom: var(--space-sm);

		.orion-input {
			flex: 1;
		}
	}

	&__section {
		position: relative;
		display: flex;
		flex-direction: column;
		margin-bottom: var(--space-md);
	}

	&__user {
		display: flex;
		gap: 1rem;
		align-items: center;
		height: 100%;

		&-name {
			display: flex;
			gap: 1rem;
			align-items: center;
			font-size: 0.85rem;
			font-weight: 700;
			color: var(--grey-darker);
		}

		&-mail {
			font-weight: 400;
			color: var(--info);
		}
	}
}
</style>
